<template>
  <a-spin :spinning="loading" tip="در حال ثبت اطلاعات">
    <a-list :locale="{emptyText:'رکوردی وجود ندارد.'}" bordered item-layout="horizontal">
      <a-list-item class="grid grid-cols-4" style="direction: rtl" v-for="(item,index) in contract"
                   :key="index">
        <div class="col-span-3 grid grid-cols-3">
          <div class="mt-5">حقوق پایه :
            {{ item.salary }}
          </div>
          <div class="mt-5">تاریخ خاتمه :
            {{ item.end_atj | jtjdate }}
          </div>
          <div class="mt-5">تاریخ شروع :
            {{ item.start_atj | jtjdate }}
          </div>
          <div class="mt-5">بن کارگری :
            {{ item.worker_coupon }}
          </div>
          <div class="mt-5">کمک هزینه مسکن :
            {{ item.housing_allowance }}
          </div>
          <div class="mt-5">حق جذب : {{ item.right_attraction }}</div>
          <div class="mt-5"> شماره سفته :
            {{ item.promissory_number }}
          </div>
          <div class="mt-5"> مبلغ سفته :
            {{ item.promissory }}
          </div>
          <div class="mt-5"> حق سرپرستی :
            {{ item.right_guardianship }}
          </div>
          <div class="mt-5"> علی الحساب سنوات :
            {{ item.years }}
          </div>
          <div class="mt-5"> عیدی :
            {{ item.eidi }}
          </div>
          <div class="mt-5"><span>شماره قرارداد :</span>&nbsp;<span>{{ item.contract_number }}</span>
          </div>
          <div class="mt-5">دلیل فسخ قرارداد :
            {{ item.reason_termination }}
          </div>
          <div class="mt-5">تاریخ فسخ قرارداد :
            {{ item.datej_termination | jtjdate }}
          </div>
          <div class="mt-5">نوع قرارداد :
            {{ item.type_str }}
          </div>
          <div class="mt-5">محل خدمت :
            {{ item.cnt.value }}
          </div>
        </div>
        <div class="grid grid-cols-1" style="direction: ltr">
          <div class="mt-5">
            <a-button :disabled="!$getAccess('personnel.contract.termination')"
                      v-if="!item.date_termination" class="ml-3" @click="showTerminationModal(index)">فسخ
              قرارداد
            </a-button>
            <a-button :disabled="!$getAccess('personnel.contract.no.termination')" v-else class="ml-3"
                      @click="removetermination(index)">لغو فسخ قرارداد
            </a-button>
            <a-button :disabled="!$getAccess('personnel.contract')" v-if="item.file" class="ml-3"
                      target="_blank" type="primary" :href="item.file.storage">دانلود پیوست
            </a-button>
          </div>
          <div class="mt-5">
            <a-tooltip :disabled="!$getAccess('personnel.contract.delete')" placement="bottomRight"
                       class="ml-3">
              <template slot="title">
                <span>حذف</span>
              </template>
              <a-popconfirm
                  placement="right"
                  title="آیا می خواهید حذف کنید؟"
                  ok-text="بله"
                  cancel-text="خیر"
                  @confirm="removeContract(item)">
                <a-button type="danger" class="mt-3 mr-3">حذف</a-button>
              </a-popconfirm>
            </a-tooltip>
            <a-dropdown class="mb-4">
              <a-menu slot="overlay" @click="printContract($event,item.id)">
                <a-menu-item v-for="(subItem,subIndex) in contractTypes" :key="subIndex">{{ subItem }}
                </a-menu-item>
              </a-menu>
              <a-button style="margin-left: 8px"> چاپ قرارداد
                <a-icon type="down"/>
              </a-button>
            </a-dropdown>
            <a-button class="ml-3" :disabled="!$getAccess('personnel.contract.update')"
                      @click="openEditingContractModal(item,index)">ویرایش
            </a-button>
          </div>
        </div>

      </a-list-item>
    </a-list>
    <a-button class="mt-3 ml-2" @click="showAddContract = true">افزودن ردیف</a-button>

<!--    modal add edit    -->
    <a-modal @ok="detectEditMode" :okText="editContractFlag?'ویرایش':'ایجاد'" forceRender cancelText="بستن"
             v-model="showAddContract" :title="editContractFlag?'ویرایش قرارداد':'افزودن قرارداد'"
             :forceRender="true">
      <a-form :form="fromContract">
        <div class="grid grid-cols-2 gap-4">
          <div>
            <a-form-item label="تاریخ شروع">
              <input v-if="!contractModel.start_at" class="hidden" autocomplete="off"
                     v-decorator="['note',{ rules:[{ required: true, message: 'تاریخ را وارد نمایید' }] }]"/>
              <date-picker v-model="contractModel.start_at"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="تاریخ خاتمه">
              <input v-if="!contractModel.end_at" class="hidden" autocomplete="off"
                     v-decorator="['note',{ rules:[{ required: true, message: 'تاریخ را وارد نمایید' }] }]"/>
              <date-picker v-model="contractModel.end_at"/>
            </a-form-item>
          </div>
        </div>
        <div class="grid grid-cols-3 gap-4">
          <div>
            <a-form-item label="حقوق پایه">
              <input class="ant-input"
                     v-decorator="['salary', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="بن کارگری">
              <input class="ant-input"
                     v-decorator="['worker_coupon', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="کمک هزینه مسکن">
              <input class="ant-input"
                     v-decorator="['housing_allowance', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="حق جذب">
              <input class="ant-input"
                     v-decorator="['right_attraction', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="حق سرپرستی">
              <input class="ant-input"
                     v-decorator="['right_guardianship', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
            <a-form-item label="عیدی">
              <input class="ant-input"
                     v-decorator="['eidi', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
            <a-form-item label="علی الحساب سنوات">
              <input class="ant-input"
                     v-decorator="['years', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="مبلغ سفته">
              <input class="ant-input"
                     v-decorator="['promissory', { initialValue: 0 },{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="شماره سفته">
              <input class="ant-input"
                     v-decorator="['promissory_number',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="شماره قرارداد">
              <input class="ant-input"
                     v-decorator="['contract_number']"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="حق فرزند">
              <input class="ant-input"
                     v-decorator="['right_child',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="پایه سنوات">
              <input class="ant-input"
                     v-decorator="['basic_years',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="حق ماموریت">
              <input class="ant-input"
                     v-decorator="['right_mission',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="حق شیفت">
              <input class="ant-input"
                     v-decorator="['right_shift',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="پاداش مستمر">
              <input class="ant-input"
                     v-decorator="['reward',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <a-form-item label="نوع قرارداد">
            <a-select v-model="contractType" style="width: 100%" v-decorator="['type']">
              <a-select-option v-for="(item,index) in contractTypes" :value="`${index}`">
                {{ item }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <div>
            <a-form-item label="حق السعی">
              <input class="ant-input"
                     v-decorator="['right_try',{ rules: [{pattern:/^[0-9]+$/,message:'مقدار وارد شده باید عددی باشد.'},] }]"/>
            </a-form-item>
          </div>

          <div>
            <a-form-item label="محل خدمت">
              <input class="ant-input" v-decorator="['city_workplace']"/>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="واحد کار">
              <a-select
                  v-decorator="['work_unit', { initialValue:null,rules: [{ required: true, message: 'لطفاسطح مقدار را انتخاب کنید' }] }]"
                  @change="selectChange">
                <a-select-option v-for="item in work_units" :value="item.id">
                  {{ item.value }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </div>
          <div>
            <a-form-item label="نام واحد" has-feedback v-if="showName">
              <input class="ant-input"
                     v-decorator="['work_unit_name', { rules: [{ required: true, message: 'لطفا مقدار را وارد کنید' }] }]"
                     autocomplete="off"
              />
            </a-form-item>
          </div>
        </div>
        <!--<a-form-item label="دلیل فسخ قرارداد">
            <input class="ant-input"   style="width: 100%" v-decorator="['reason_termination']"  />
        </a-form-item>-->
        <a-form-item label="فایل">
          <div class="dropbox">
            <a-upload-dragger
                :disabled="!$getAccess('personnel.basic.update')"
                :multiple="false"
                action="http://hr.asco-intl.com:2020/kernel/api/register/upload"
                :file-list="contractFileList"
                :default-file-list="contractFileList"
                @change="contractFileUpload"
                :remove="contractFileRemove"
            >
              <p class="ant-upload-drag-icon">
                <a-icon type="inbox"/>
              </p>
              <p class="ant-upload-text">
                فایل را درگ کنید یا اینکه کاوش کنید.
              </p>
              <p class="ant-upload-hint">
                فایلی که بارگذاری می کنید باید زیر ۵ مگابایت باشد.
              </p>
            </a-upload-dragger>

            <!--                    <a-upload-dragger
                                    :customRequest="uploadImage"
                                    :file-list="contractFileList"
                                    :before-upload="beforeUpload"
                                >
                                  <p class="ant-upload-drag-icon">
                                    <a-icon type="inbox" />
                                  </p>
                                  <p class="ant-upload-text">
                                    فایل را درگ کنید یا اینکه کاوش کنید.
                                  </p>
                                  <p class="ant-upload-hint">
                                    تصویر که بارگذاری می کنید باید زیر ۵ مگابایت باشد.
                                  </p>
                                </a-upload-dragger>-->
            <!--                    <div v-else>
                                  <a-alert message="آپلود سند با موفقیت انجام شد." type="success" />
                                </div>-->
          </div>
        </a-form-item>
      </a-form>
    </a-modal>
<!--    modal add edit    -->

<!--    modal termision    -->
    <a-modal okText="ثبت" cancelText="بستن" forceRender v-model="showTermination" title="فسخ قرارداد"
             @ok="addtermination">
      <a-form :form="formTermination">
        <a-form-item label="تاریخ فسخ قرارداد">
          <input v-if="!date_termination" class="hidden" autocomplete="off"
                 v-decorator="['note',{ rules:[{ required: true, message: 'تاریخ را وارد نمایید' }] }]"/>
          <date-picker v-model="date_termination"/>
        </a-form-item>
        <a-form-item label="دلیل فسخ قرارداد">
          <input class="ant-input" autocomplete="off" v-decorator="['reason_termination']"/>
        </a-form-item>
      </a-form>
    </a-modal>
<!--    modal termision    -->

<!--    <a-button type="primary" @click="saveData" class="mt-5" :disabled="disabled"
              v-if="contract && contract.length > 0">
      ویرایش
    </a-button>-->


  </a-spin>
</template>
<script>
import axios from "@/axios";

export default {
  name: "contracts",
  props: {
    contract:{
      type: Array,
      required: true
    }
  },
  data() {
    return{
      showAddContract: false,
      loading: false,
      fromContract: this.$form.createForm(this, {name: 'fromContract'}),
      formTermination: this.$form.createForm(this, {name: 'formTermination'}),
      editContractFlag: false,
      showTermination: false,
      activeContract: null,
      date_termination: null,
      contractModel: {
        start_at: '',
        end_at: '',
        salary: 0,
        worker_coupon: 0,
        housing_allowance: 0,
        right_attraction: 0,
        right_guardianship: 0,
        reason_termination: ''
      },
      contractFileList: [],
      work_units: [],
      showName: false,
      contractTypes: undefined,
      contractType: "1",
    }
  },
  methods: {
    async getUnits() {
      try {
        let {data} = await axios.get('/personnel/unit/unit')
        await this.$store.commit('personnel/setUnits', data)
        data.push
        ({
          id: "new",
          value: "افزودن واحد جدید"
        })
        this.work_units = data
      } catch (e) {
         console.log(e)
      }
    },
    selectChange(id) {
      if (id == "new") {
        this.showName = true
      }
      else if(this.showName == true) this.showName = false
    },
    async getTypes() {
      try {
        const {data} = await axios.get('/personnel/type/type')
        this.contractTypes = data
        await this.$store.commit('personnel/setContractTypes', data)
      } catch (e) {
         console.log(e)
      }
    },
    showTerminationModal(index) {
      this.activeContract = index;
      this.showTermination = true;
    },
    async removetermination(index) {
      try {
        let contractList = this.contract
        contractList[index].date_termination = null
        contractList[index].datej_termination = null
        contractList[index].reason_termination = null
        await this.saveData(contractList);
      } catch (e) {
        this.$ntSetError()

        console.log(e)
      } finally {
        await this.getPersonal()
      }
    },
    async removeContract(item) {
      if (item.id) {
        try {
          await axios.post('/personnel/remove-contract', {id: item.id});
          await this.$emit('update')
        } catch (e) {
        console.log(e);
        }
      } else {
        const index = this.contract.indexOf(item);
        this.contract.splice(index, 1);
      }
    },
    printContract(event, id) {
      window.open(`http://hr.asco-intl.com:2020/kernel/api/personnel/print?type=${event.key}&id=${id}`, '_blank').focus()
    },
    openEditingContractModal(item, index) {
      // console.log(this.contractTypes)
      // console.log(item)
      item.type = item.type ? item.type.toString() : undefined
      if (item.file) {
        this.contractFileList = [{uid: item.file.id, name: item.file.filename, status: 'done', url: item.file.storage}]
      }
      this.activeContract = index
      this.editContractFlag = true
      this.showAddContract = true
      this.contractModel.end_at = item.end_at
      this.contractModel.start_at = item.start_at
      // console.log("item:::::::::::::",item)
      // console.log(item)
      this.fromContract.setFieldsValue(item)

    },
    async detectEditMode(e) {
      await this.addContract(e)
      if (this.editContractFlag) this.editContractFlag = false
    },
    addContract(e) {
      e.preventDefault();
      this.fromContract.validateFields((err, values) => {
        if (!err) {
          let contractList = this.contract
          if (this.image_data) {
            values.contract_file_id = this.image_data.id
          }
          if (values.work_unit == "new") {
            values.work_unit = values.work_unit_name
          }
          if (this.editContractFlag) {
            values.start_at = this.contractModel.start_at
            values.end_at = this.contractModel.end_at
            contractList[this.activeContract] = Object.assign(this.contract[this.activeContract], values)
            // console.log("model", this.contractModel)
            this.contractModel = {
              start_at: '',
              end_at: '',
              salary: 0,
              worker_coupon: 0,
              housing_allowance: 0,
              right_attraction: 0,
              right_guardianship: 0,
              reason_termination: ''
            }
          }
          else {
            // console.log("adding")
            values.start_at = this.contractModel.start_at
            values.end_at = this.contractModel.end_at
            contractList.push(values);
          }
          // console.log("data", this.contract[this.editingContractIndex])
          this.saveData(contractList);
          this.showAddContract = false;
          this.fromContract.resetFields();
          this.image_data = null;
          // console.log('contract',this.contract);
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      });
    },
    contractFileUpload({fileList, event, file}) {
      if (file.response && file.response.id) {
        this.image_data = file.response
      }
      this.contractFileList = fileList;
    },
    contractFileRemove() {
      this.image_data = null
    },
    async addtermination(e) {
      e.preventDefault();
      this.formTermination.validateFields(async (err, values) => {
        if (!err) {
          try {
            let contractList = this.contract
            contractList[this.activeContract].date_termination = this.date_termination //values.date_termination;
            contractList[this.activeContract].reason_termination = values.reason_termination;
            this.showTermination = false;
            this.formTermination.resetFields();
            await this.saveData(contractList);
          } catch (e) {
            this.$ntSetError()

        console.log(e)
          } finally {
            this.$refs.personelTbl.fetch();
          }
        } else {
          this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
        }
      });
    },
    async saveData(contractList) {
      if (contractList) {
        try {
          this.loading = true
          console.log('contractList',contractList)
          let values = {
            contract: contractList,
            id: this.id
          }
          if (!this.$getAccess('personnel.contract')) {
            values.contract = this.contract
          }
          await axios.post(`/personnel/contract/update`, values)
          this.$ntSet()
        } catch (e) {
          this.$ntSetError()
          console.log(e)
        } finally {
          await this.$emit('update')
          this.loading = false
          this.showAddContract = false
        }
      }
      else {
        this.$ntGetError('اطلاعات را به صورت کامل وارد کنید');
      }
    },
  },
  computed: {
    id() {
      return this.$route.params.id
    }
  },
  async created() {
    await this.getTypes()
    await this.getUnits()
  },
}
</script>

<style scoped>

</style>